// removed by extract-text-webpack-plugin
module.exports = {"classtop-search-list":"classtop-search-list","classtop-modal-content":"classtop-modal-content","Select-control":"Select-control","select-none":"select-none","searchbar-wrapper":"searchbar-wrapper","Select-arrow":"Select-arrow","Select-placeholder":"Select-placeholder","Select-clear-zone":"Select-clear-zone","label-section":"label-section","sort-btn":"sort-btn","select-list":"select-list","select-item":"select-item","select-button":"select-button","btn-link":"btn-link","currently-selected":"currently-selected","Select-clear":"Select-clear"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/SearchList/SearchList.scss
// module id = bH5w
// module chunks = 0